import {
  Injectable
} from '@angular/core';
import {
  MatSnackBar
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotifierService {

  constructor(private snackBar: MatSnackBar) {}

  public showNotification(message: string, buttonText, messageType: 'error' | 'success' | undefined = undefined) {
    this.snackBar.open(message, buttonText, {
      duration: 5000000,
      horizontalPosition: "center",
      verticalPosition: "bottom",
      panelClass: messageType
    })
  }
}
